module.exports = __webpack_public_path__ + "static/media/octagon.36a8ffc4.svg";